var _defs, _rect, _rect2, _circle, _circle2, _circle3, _rect3, _rect4, _polyline, _line, _line2, _line3, _rect5, _rect6, _rect7, _rect8, _text, _text2, _text3, _text4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 400",
    width: 800,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#e8f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f7fbff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 400,
    rx: 16,
    fill: "url(#g)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 760,
    height: 40,
    rx: 8,
    fill: "#ffffff",
    stroke: "#dbe9f6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 40,
    r: 6,
    fill: "#e57373"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 40,
    r: 6,
    fill: "#ffb74d"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 40,
    r: 6,
    fill: "#81c784"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 76,
    width: 360,
    height: 304,
    rx: 12,
    fill: "#ffffff",
    stroke: "#dbe9f6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 76,
    width: 360,
    height: 304,
    rx: 12,
    fill: "#ffffff",
    stroke: "#dbe9f6"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "40,350 80,300 120,320 160,250 200,270 240,200 280,210 320,160 360,180",
    fill: "none",
    stroke: "#2563eb",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 340,
    x2: 360,
    y2: 340,
    stroke: "#e6edf3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 300,
    x2: 360,
    y2: 300,
    stroke: "#e6edf3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 260,
    x2: 360,
    y2: 260,
    stroke: "#e6edf3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 96,
    width: 320,
    height: 60,
    rx: 10,
    fill: "#f4f9ff",
    stroke: "#d7e8fa"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 166,
    width: 320,
    height: 60,
    rx: 10,
    fill: "#ffffff",
    stroke: "#e6edf3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 236,
    width: 320,
    height: 60,
    rx: 10,
    fill: "#ffffff",
    stroke: "#e6edf3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 306,
    width: 320,
    height: 60,
    rx: 10,
    fill: "#ffffff",
    stroke: "#e6edf3"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 132,
    fill: "#0b1f2a",
    fontFamily: "Segoe UI, Roboto, Arial",
    fontSize: 18
  }, "Compliance Score")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 200,
    fill: "#35556b",
    fontFamily: "Segoe UI, Roboto, Arial",
    fontSize: 14
  }, "New alerts")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 270,
    fill: "#35556b",
    fontFamily: "Segoe UI, Roboto, Arial",
    fontSize: 14
  }, "Recent changes")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 340,
    fill: "#35556b",
    fontFamily: "Segoe UI, Roboto, Arial",
    fontSize: 14
  }, "Open items")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.ef08f451a47da989001b8a6c58293fcc.svg";
export { ForwardRef as ReactComponent };